import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import FlatButton from 'material-ui/FlatButton'
import RecoverIcon from 'material-ui/svg-icons/social/person-add'

import { push as pushAction } from 'react-router-redux'
import { showNotification as showNotificationAction } from 'admin-on-rest'

import constants from '../utils/constants'

const style = {
  color: '#00244D',
  backgroundColor: '#EB9413'
}

class RecoverUserButton extends Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick () {
    const { record, showNotification } = this.props

    const url = `${constants.apiUrl}/user/undelete/${record.id}`
    const options = {
      method: 'PUT',
      // eslint-disable-next-line
      headers: new Headers({'Authorization': localStorage.getItem('token')})
    }

    // eslint-disable-next-line
    fetch(url, options)
      .then(() => {
        showNotification('Usuário recuperado!')
        window.location.reload()
      })
      .catch(() => {
        showNotification('Erro: ocorreu um problema!', 'warning')
        window.location.reload()
      })
  }

  render () {
    return (
      <FlatButton
        style={style}
        label='Recuperar'
        icon={<RecoverIcon />}
        onClick={this.handleClick}
      />
    )
  }
}

RecoverUserButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
}

export default connect(null, {
  push: pushAction,
  showNotification: showNotificationAction
})(RecoverUserButton)



// WEBPACK FOOTER //
// ./src/components/recoverUserButton.js